<script>
//TODO: Actually this component doesn't work for video.

import CTA from '@phoenix/mixins/components/common/CTA';
import { showModal } from '@phoenix/helpers/modal-helper';
import { PhxIcon } from '@phx-styleguides/pia';

export default {
  components: { PhxIcon },

  mixins: [CTA],

  props: {
    type: {
      type: String,
      default: 'default',
    },
    trackingEvent: {
      type: String,
      default: '',
    },
    additionalClasses: {
      type: String,
      default: '',
    },
  },

  computed: {
    attributes() {
      const attributes = {};
      if (this.target.type === 'page' && this.target.openInNewWindow) {
        attributes.target = '_blank';
      }
      return attributes;
    },

    modalId() {
      switch (this.target.type) {
        case 'video':
          return this.target.videoModalId;
        case 'sharePage':
          return this.target.modalId;
        default:
          return null;
      }
    },

    shouldOpenModal() {
      return this.modalId !== null;
    },

    trackingDatalayer() {
      return this.trackingEvent ? window.tracking.getCustomEventTracking(this.trackingEvent) : null;
    },

    baseClasses() {
      return ['btn', this.additionalClasses];
    },
  },
  methods: { showModal },
};
</script>

<template>
  <button v-if="shouldOpenModal" v-bind="attributes" :class="getClasses" @click="showModal(modalId)">
    <span v-if="icon" class="btn__icon btn__icon--start">
      <phx-icon :icon="icon" class="icon--sm" />
    </span>
    <span class="btn__text">
      <span v-html="getText" />
    </span>
  </button>

  <a v-else :href="link" v-bind="attributes" :class="getClasses">
    <span v-if="icon" class="btn__icon btn__icon--start">
      <phx-icon :icon="icon" class="icon--sm" />
    </span>
    <span class="btn__text">
      <span v-html="getText" />
    </span>
  </a>
</template>
